import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import { getToken, removeToken } from './auth'
import router from '@/router'

// API 基础配置
// const API_BASE_URL = 'http://192.168.0.104:8080/api' || '/api'
// const API_BASE_URL_PRODUCTION = 'http://192.168.0.104:8080/api/'


const API_BASE_URL = 'https://betelnut.mytopall.cn/api/'

const API_BASE_URL_PRODUCTION = 'https://betelnut.mytopall.cn/api/'


// 创建 axios 实例
const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 50000
})

// 导出上传接口的完整 URL
export const UPLOAD_URL = API_BASE_URL_PRODUCTION + 'admin/uploadImgOriginal'
export const UPLOAD_COMPRESSED_URL = API_BASE_URL_PRODUCTION + 'admin/uploadImg'
export const UPLOAD_LOCAL_URL = API_BASE_URL_PRODUCTION + 'admin/uploadImgLocal'
export const UPLOAD_LOCAL_COMPRESSED_URL = API_BASE_URL_PRODUCTION + 'uploadImgLocalCompressed'
export const PRIZE_UPLOAD_URL = API_BASE_URL_PRODUCTION + 'admin/prize/upload'

let isRedirectingToLogin = false

function redirectToLogin() {
  if (router.currentRoute.path === '/login' || isRedirectingToLogin) return
  isRedirectingToLogin = true
  router.replace('/login').catch(() => {}).finally(() => {
    isRedirectingToLogin = false
  })
}

// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = getToken()
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    console.log('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    if (response.config.responseType === 'blob') {
      return response
    }
    const res = response.data
    
    // 如果返回的状态码不是0或200，说明接口有问题
    if (res.code !== 0 && res.code !== 200) {
      // 401: Token 过期或无效
      if (res.code === 401||res.code === 403) {
        removeToken()
        redirectToLogin()
        return Promise.resolve(res)
      }
      
      Message({
        message: res.msg || '请求失败',
        type: 'error',
        duration: 5 * 1000
      })
      
      return Promise.resolve(res)
    } else {``
      return res
    }
  },
  error => {
    console.log('响应错误:', error)
    
    // 处理401和403错误（认证失败）
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      removeToken()
      Message({
        message: error.response.data?.msg || '登录已过期，请重新登录',
        type: 'warning',
        duration: 3 * 1000
      })
      redirectToLogin()
      // 返回完整的响应数据，包括 msg 字段
      return Promise.resolve(error.response.data || { code: error.response.status })
    }
    
    // 其他错误
    Message({
      message: t(error.response?.data?.msg || '网络请求失败，请稍后重试'),
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
